import React from "react";
import { Menu, Dropdown, Avatar, Button } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { getInitials } from "helpers/string.helper";
import { useAuth } from "stores/auth.store";

export const NavProfile = () => {
  const { name, logout } = useAuth();

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-body">
        <Menu>
          <Menu.Item
            style={{
              cursor: "default",
              pointerEvents: "none",
              background: "transparent",
              color: "#555",
            }}
            disabled
          >
            <Icon type={UserOutlined} />
            <span className="font-weight-normal">{name}</span>
          </Menu.Item>
          <Menu.Item onClick={e => logout()}>
            <span>
              <LogoutOutlined />
              <span className="font-weight-normal">Sair da conta</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown
      placement="bottomRight"
      overlay={profileMenu}
      trigger={["click"]}
    >
      <Button
        type="text"
        className="w-100 h-100 p-0 d-flex justify-content-center align-items-center shadow-none bg-transparent"
      >
        <div className="d-flex align-items-center justify-content-center">
          <Avatar
            size={45}
            className="bg-gray-light"
          >
            {getInitials(name)}
          </Avatar>
        </div>
      </Button>
    </Dropdown>
  );
};

export default NavProfile;
